import { prop } from 'datx';

import { BaseModel } from './BaseModel';

export enum ContactType {
  SUPPORT = 'support',
  PRESS = 'press',
  CONFERENCES = 'conferences',
}

export class Contact extends BaseModel {
  public static type = 'contact';

  @prop
  public name: string;

  @prop
  public email: string;

  @prop
  public message: string;

  @prop
  public eventName?: string;

  @prop
  public dayCount?: string;

  @prop
  public attendeeCount?: string;

  @prop
  public lectureCount?: string;

  @prop
  public type: ContactType;
}
